export const COVERED_URI = 'https://newquote.itscovered.com/homebot'
export const HOME_INSURANCE_TYPES = {
  DISABLED: 'disabled',
  GENERIC: 'generic',
  COVERED: 'covered'
}
export const HOME_INSURANCE_RISKS = {
  LOW: 'low',
  MID: 'mid',
  HIGH: 'high'
}
